module.exports = __webpack_public_path__ + "static/media/iconSepultura2.15a4bd99.svg";